/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.tabList {
  display: flex;
  border-style: var(--tw-border-style);
  border-width: 0px;
  border-bottom-style: var(--tw-border-style);
  border-bottom-width: 2px;
  border-color: var(--color-emphasis-low, #d4d4d4);
  --tw-border-style: solid;
  border-style: solid;
  white-space: nowrap;
}
.tabList li {
  list-style-type: none;
}
.stick-to-top {
  position: sticky;
  top: 0px;
  z-index: 10;
  background-color: var(--color-white, #fff);
}
.tabItem a {
  display: flex;
  gap: calc(var(--spacing, 0.25rem) * 2);
  align-items: center;
  color: var(--color-gray-600, #525252);
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  cursor: pointer;
  margin-bottom: calc(2px * -1);
  padding: calc(var(--spacing, 0.25rem) * 2);
  @media (width >= 40rem) {
    padding-inline: calc(var(--spacing, 0.25rem) * 4);
  }
  @media (width >= 40rem) {
    padding-block: calc(var(--spacing, 0.25rem) * 3);
  }
  --tw-border-style: solid;
  border-style: solid;
  text-decoration-line: none;
  border-style: var(--tw-border-style);
  border-width: 0px;
  border-bottom-style: var(--tw-border-style);
  border-bottom-width: 2px;
  border-color: var(--color-emphasis-low, #d4d4d4);
}
.tabItem a:hover {
  color: var(--color-emphasis-high, #000);
  border-color: var(--color-emphasis-medium, #525252);
}
.tabItem a[aria-current="page"] {
  color: var(--color-emphasis-extra, var(--color-primary-500));
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  border-color: var(--color-emphasis-extra, var(--color-primary-500));
}
.tabItem a[data-selected="true"] {
  color: var(--color-emphasis-extra, var(--color-primary-500));
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  border-color: var(--color-emphasis-extra, var(--color-primary-500));
}
.tabItem svg {
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-font-weight: initial;
    }
  }
}
